import { Immutable } from "immer";
import React from "react";
import { usePageSetting } from "tsi-common-react/src/utils/settings";

import type { PreQualificationBlock as PreQualificationBlockValue } from "@reactivated";

import { FinancingModalTriggerBlock } from "../../apps/checkout/FinancingModalTriggerBlock";

type IProps = Immutable<{ value: PreQualificationBlockValue | null }>;

export const PreQualificationBlock = (
    _props: IProps,
): React.JSX.Element | null => {
    const showPrequalHomepage = usePageSetting("show_prequal_homepage");
    if (!showPrequalHomepage) {
        return null;
    }

    return <FinancingModalTriggerBlock />;
};
